module.exports = __webpack_public_path__ + "img/qrcode_icon.a5a67c52.svg";